import React from 'react'
import { LPContextProvider } from '../../../layouts/LearningPath/Layout/Context/LPContext'
import Loader from '../../../layouts/LearningPath/Layout/Loader'
import { SkillTutorTabLayout } from '@features/skillsTutor/components'
import { useSkillsTutorData } from '@features/skillsTutor/hooks'

const SkillsTutorTab: React.FC = () => {
  const {
    loading,
    error,
    skillsTutorProducts,
    LearningPaths,
    skillsTutorMaterials,
    skillsTutorMaterialsLoaded,
    activeLearningLanguage,
    refresh,
    refreshUntilConsistent,
    isRefreshing,
    refreshPhase,
  } = useSkillsTutorData()

  if (loading) {
    return <Loader />
  }

  return (
    <LPContextProvider>
      <SkillTutorTabLayout
        key={LearningPaths?.LearningPaths?.length}
        LearningPaths={LearningPaths}
        error={error}
        skillsTutorProducts={skillsTutorProducts}
        skillsTutorMaterials={skillsTutorMaterials}
        skillsTutorMaterialsLoaded={skillsTutorMaterialsLoaded}
        activeLearningLanguage={activeLearningLanguage}
        onSkillsTutorDataRefresh={refresh}
        onSkillsTutorDataRefreshUntilConsistent={refreshUntilConsistent}
        isSkillsTutorRefreshing={isRefreshing}
        skillsTutorRefreshPhase={refreshPhase}
      />
    </LPContextProvider>
  )
}

export default SkillsTutorTab

